module.exports = __webpack_public_path__ + "img/icon-marker-accent-3.e143bf58.svg";